import { Text } from '@bendhealth/common';
import styled from '@emotion/styled';
import HalDance from 'public/assets/img/buddies/HYP-Excited.gif';

export const LandingBackground = styled.div<{ bgColor?: string }>`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 64px;
  gap: 24px;
  @media (max-width: 1024px) {
    padding: 12px;
  }
  width: 100%;
  height: 100%;
  min-height: 700px;
  background: ${({ bgColor }) =>
    bgColor || 'linear-gradient(115.7deg, #078189 2.94%, #018847 98.76%)'};
  border-radius: 40px;
  flex: none;
  order: 0;
  align-self: stretch;
  flex-grow: 1;
`;
export const LandingBody = styled.div`
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  padding: 0px 16px 16px;
  margin-top: 50px;
  width: 100%;
  @media (min-width: 750px) {
    margin-top: 90px;
  }
  @media (min-width: 1024px) {
    height: calc(100vh - 90px);
  }
  @media (max-width: 1024px) {
    padding-left: 8px;
    padding-right: 8px;
  }
  background: #ffffff;
  flex: none;
  order: 0;
  align-self: stretch;
  flex-grow: 1;
  z-index: 0;
`;
export const LandingContent = styled.div`
  display: flex;
  align-items: flex-start;
  gap: 64px;
  align-self: stretch;
  @media (max-width: 1024px) {
    width: 100%;
    gap: 40px;
  }
  @media (max-width: 1024px) {
    flex-direction: column;
  }
`;
export const LandingLeftColumn = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  padding: 0px 16px;
  gap: 24px;
  isolation: isolate;
  flex: none;
  order: 0;
  flex-grow: 1;
  width: 45%;
  @media (max-width: 1024px) {
    width: 100%;
    padding: 0.75rem;
  }
`;
export const LandingRightColumn = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  padding: 0px;
  gap: 24px;
  flex: none;
  order: 1;
  flex-grow: 0;
  width: 45%;
  @media (max-width: 1024px) {
    width: 100%;
    gap: 16px;
  }
`;
export const LandingTitle = styled.h1`
  @media (max-width: 1024px) {
    font-size: 36px;
    font-weight: 900;
    line-height: 39.6px;
  }
  font-style: normal;
  font-weight: 900;
  font-size: 64px;
  line-height: 110%;
  color: #ffffff;
  flex: none;
  order: 1;
  align-self: stretch;
  flex-grow: 0;
`;
export const LandingImageContainer = styled.div`
  width: 196.21px;
  height: 160px;
  position: relative;
  gap: 0px;
  opacity: 0px;

  @media (max-width: 1024px) {
    width: 196.21px;
    height: 160px;
    gap: 0px;
    opacity: 0px;
    align-self: center;
  }
`;
export const LandingImage = styled.div`
  position: absolute;
  z-index: 2;
  width: 180px;
  height: 190px;
  top: -17px;
  left: -8px;
  gap: 0px;
  opacity: 1;

  background: url(${HalDance});
  background-color: transparent;
  background-size: contain;
  background-repeat: no-repeat;
  background-position: center;
`;
export const LandingEllipse = styled.div<{ color?: string }>`
  position: absolute;
  z-index: 1;
  width: 144.75px;
  height: 144.75px;
  top: 7.72px;
  left: 25.84px;
  gap: 0px;
  opacity: 0.35;
  background: ${({ color }) => color || '#6fc5c5'};
  border-radius: 50%;
  flex: none;
  order: 0;
  align-self: center;
  flex-grow: 0;
`;
export const LandingInfoContainer = styled.div`
  gap: 12px;
  display: flex;
  flex-direction: column;
`;
export const LandingInfo = styled.div<{ color?: string }>`
  font-style: normal;
  font-weight: 400;
  font-size: 18px;
  line-height: 150%;
  text-align: left;
  text-underline-position: from-font;
  text-decoration-skip-ink: none;
  @media (max-width: 1024px) {
    font-size: 16px;
    font-weight: 400;
    line-height: 22.4px;
  }
  color: ${({ color }) => color || '#d0f3dc'};
  flex: none;
  order: 2;
  align-self: stretch;
  flex-grow: 0;
`;
export const LandingInfoHeader = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  padding: 0px 12px;
  gap: 12px;
  @media (max-width: 1024px) {
    padding: 0.75rem;
  }
  flex: none;
  order: 0;
  align-self: stretch;
  flex-grow: 0;
`;
export const LandingVector = styled.div`
  width: 24px;
  height: 0px;
  border: 2px solid #ffa578;
  flex: none;
  order: 0;
  flex-grow: 0;
`;
export const LandingTextHeader = styled.div<{ color?: string }>`
  font-style: normal;
  font-weight: 400;
  font-size: 16px;
  line-height: 150%;
  color: ${({ color }) => color || '#d0f3dc'};
  flex: none;
  order: 1;
  align-self: stretch;
  flex-grow: 0;

  @media (max-width: 1024px) {
    font-size: 14px;
    font-weight: 400;
    line-height: 19.6px;
  }
`;
export const LandingSteps = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  padding: 40px 32px;
  gap: 20px;
  isolation: isolate;
  width: 100%;
  background: rgba(0, 0, 0, 0.24);
  backdrop-filter: blur(64px);
  border-radius: 32px;
  flex: none;
  order: 1;
  align-self: stretch;
  flex-grow: 0;
  @media (max-width: 1024px) {
    padding: 3rem 1.5rem;
  }
`;
export const LandingStepHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  align-self: stretch;
  padding: 0px;
  flex: none;
  order: 1;
  align-self: stretch;
  flex-grow: 0;
`;
export const LandingStepTitle = styled.div<{ color?: string }>`
  font-size: 28px;
  font-weight: 400;
  line-height: 39.2px;
  text-align: left;
  text-underline-position: from-font;
  text-decoration-skip-ink: none;
  @media (max-width: 1024px) {
    font-size: 21px;
    font-weight: 400;
    line-height: 29.4px;
  }
  color: ${({ color }) => color || '#80d59d'};
  flex: none;
  order: 0;
  flex-grow: 0;
`;
export const LandingStepSubTitle = styled(Text)`
  font-size: 16px;
  font-weight: 400;
  line-height: 24px;
  text-align: left;
  text-underline-position: from-font;
  text-decoration-skip-ink: none;

  @media (max-width: 1024px) {
    font-size: 14px;
    font-weight: 400;
    line-height: 19.6px;
  }
  color: #ffffff;
  flex: none;
  order: 1;
  flex-grow: 0;
`;
export const LandingStepListContainer = styled.div`
  order: 2;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 16px;
  align-self: stretch;
`;
export const LandingStepListEl = styled.div`
  display: flex;
  align-items: flex-start;
  gap: 12px;
  align-self: stretch;
  @media (max-width: 1024px) {
    padding-bottom: 8px;
  }
`;
export const LandingStepListElIcon = styled.div`
  display: flex;
  width: 32px;
  height: 32px;
  padding: 4.571px;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  border-radius: 42.286px;
  background: rgba(0, 0, 0, 0.16);
`;
export const LandingStepListElText = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
  flex: 1 0 0;
`;
export const LandingStepListElHead = styled(Text)`
  font-family: 'sofiaprosoftbold';
  font-size: 20px;
  font-weight: 400;
  line-height: 30px;
  text-align: left;
  text-underline-position: from-font;
  text-decoration-skip-ink: none;
  color: #ffffff;

  @media (max-width: 1024px) {
    font-size: 18px;
    font-weight: 400;
    line-height: 25.2px;
  }
`;

export const LandingStepListElSub = styled(Text)<{ color?: string }>`
  font-size: 16px;
  font-weight: 400;
  line-height: 24px;
  text-align: left;
  text-underline-position: from-font;
  text-decoration-skip-ink: none;
  color: ${({ color }) => color || '#d0f3dc'};

  @media (max-width: 1024px) {
    font-size: 14px;
    font-weight: 400;
    line-height: 19.6px;
  }
`;
export const LandingIconText = styled.span<{ color?: string }>`
  font-family: 'sofiaprosoftbold';
  color: ${({ color }) => color || '#80d49d'};
  leading-trim: both;
  text-edge: cap;
  font-feature-settings:
    'liga' off,
    'clig' off;
  // font-family: "Sofia Pro Soft";
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 100%; /* 16px */
`;
